import React from 'react';
import {getRendererForQuestion} from 'components/QuestionTypes/getRendererForQuestion';
import BlockedAssignmentQuestion from 'components/QuestionTypes/BlockedAssignmentQuestion/BlockedAssignmentQuestion.react';
// import {Store} from 'client/framework'; TODO-KBC: Build typescript methods
import './question-renderer.scss';

interface Props {
  actions: React.ReactNode;
  activeGuess: any;
  activeQuestion: any;
  activeQuestionSet: any;
  activeQuestionStore: any; // PropTypes.instanceOf(Store) TODO-KBC: Build typescript methods
  activeSubject: any;
  customHeader?: any;
  headingActions: React.ReactNode;
  interactive?: boolean;
  isMobile?: boolean;
  modifyTitle?: () => {};
  navigateBackProps: {[key: string]: any} | null;
  navigateNextProps: {[key: string]: any} | null;
  postSubmissionScrollPointRef: {[key: string]: any};
  rendererType: 'PreGuess' | 'PostGuess';
  showDifficulty: boolean;
  hasQuestionSetAccessPredicate: (questionSet: any) => boolean;
}

const QuestionRenderer = ({
  actions,
  activeGuess,
  activeQuestion,
  activeQuestionSet,
  activeQuestionStore,
  activeSubject,
  customHeader,
  headingActions,
  interactive,
  isMobile,
  modifyTitle,
  navigateBackProps,
  navigateNextProps,
  postSubmissionScrollPointRef,
  rendererType,
  showDifficulty,
  hasQuestionSetAccessPredicate
}: Props) => {
  const Renderer = activeQuestion.getMeta().isBlockedAssignmentQuestion()
    ? BlockedAssignmentQuestion
    : getRendererForQuestion(activeQuestion)[rendererType];
  return (
    <Renderer
      actions={actions}
      activeQuestion={activeQuestion}
      activeQuestionSet={activeQuestionSet}
      activeQuestionStore={activeQuestionStore}
      activeSubject={activeSubject || null}
      customHeader={customHeader || null}
      guess={activeGuess}
      headingActions={headingActions}
      interactive={interactive}
      isMobile={isMobile}
      modifyTitle={modifyTitle}
      navigateBackProps={navigateBackProps}
      navigateNextProps={navigateNextProps}
      postSubmissionScrollPointRef={postSubmissionScrollPointRef}
      showDifficulty={showDifficulty}
      hasQuestionSetAccessPredicate={hasQuestionSetAccessPredicate}
    />
  );
};

export default QuestionRenderer;
